import "./ClarityProgram.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ProjectOverview from "./sections/ProjectOverview";
import FeatureGrid from "./sections/FeatureGrid";
import DetailedWorkflow from "./sections/DetailedWorkflow";
import HowItWorks from "./sections/HowItWorks";
import AboutBio from "./sections/AboutBio";
import DurationAndInvestment from "./sections/DurationAndInvestment";
import ContactForm from "./sections/ContactForm";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function ClarityProgramPage() {
  return <div>
      <Header />
      <Hero />
      <ProjectOverview />
      <FeatureGrid />
      <DetailedWorkflow />
      <HowItWorks />
      <AboutBio />
      <DurationAndInvestment />
      <ContactForm />
      <FinalCta />
      <Footer />
    </div>;
}